/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OmitFunctions } from 'src/core/stores/types';

export class CustomTextTrainedModelStore {
    public id: string;

    public name: string;

    public lastTrainingDate: Date;

    public lastTrainingDuration: number;

    public expirationDate: Date;

    public trainingConfigVersion: string;

    public hasSnapshot: boolean;

    constructor(name: string, data?: Partial<OmitFunctions<Omit<CustomTextTrainedModelStore, 'name'>>>) {
        this.name = name;
        this.id = data?.id || name;
        this.lastTrainingDate = data?.lastTrainingDate;
        this.lastTrainingDuration = data?.lastTrainingDuration;
        this.expirationDate = data?.expirationDate;
        this.trainingConfigVersion = data?.trainingConfigVersion;
        this.hasSnapshot = data?.hasSnapshot;
    }
}
